export default __webpack_public_path__ + "static/media/Rule10.f4d885a7.png";